import { useEffect, useState } from 'react';
import TextField from '@mui/material/TextField';
import Modal from '@mui/material/Modal';
import Dialog from '@mui/material/Dialog';
import { Box, Container, Grid, Typography } from '@mui/material';
import { RPM } from '../App';
import { set, without } from 'lodash';

const ImportDialog = ({ showImportScreen, onSubmit, onClose }) => {
    const [showFillError, setShowFillError] = useState(false);
    const [importPoints, setImportPoints] = useState([]);

    const style = {
        // position: 'absolute',
        // top: '50%',
        // left: '50%',
        // transform: 'translate(-50%, -50%)',
        // width: '50%',
        // maxWidth: 600,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
    };

    const handleSubmitImport = (event) => {
        event.preventDefault();
        if (without(importPoints, undefined, "").length < RPM.length) {
            setShowFillError(true)
            return;
        }
        const points = []
        for (let index = 0; index < RPM.length; index++) {
            points.push({ x: RPM[index], y: importPoints[index] })
        }
        onSubmit(points);
    }


    const handleImportOnChange = (event) => {
        setShowFillError(false)
        if (event.target.value > 100) {
            event.target.value = 100
        }
        if (event.target.value < 0) {
            event.target.value = 0
        }
        if (isNaN(event.target.value)) {
            event.target.value = 0
        }
        const newArray = set(importPoints, event.target.name, event.target.value)
        setImportPoints(newArray)

    }


    return (
        <Dialog
            open={showImportScreen}
            onClose={onClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style} autoComplete="off">
                <form onSubmit={handleSubmitImport}>
                    <Grid container spacing={2}>
                        {RPM.map((speed, index) => {
                            return (
                                <Grid key={index} item xs={6}>
                                    <TextField key={index}
                                        onChange={handleImportOnChange}
                                        label={`${speed}RPM`}
                                        name={`${index}`}
                                        id="outlined-size-small"
                                        size="small"
                                        inputProps={{ inputMode: 'numeric' }}
                                        style={{ paddingBottom: 10 }
                                        }
                                    />
                                </Grid>)
                        })}
                    </Grid>
                    {showFillError && <p style={{ color: 'red' }}>Please fill all values</p>}
                    <p>
                        <input type="submit" value="Submit" />
                    </p>
                </form>
            </Box>
        </Dialog >
    )

}

export default ImportDialog;
